
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 12"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"mail-black-envelope-symbol_icon-icons.com_56519(5)"}},[_c('path',{attrs:{"data-name":"Path 7111","d":"M16 10a1.982 1.982 0 01-.257.962L10.691 5.31l5-4.372A1.985 1.985 0 0116 2v8zM8 6.336L14.953.249A1.975 1.975 0 0014 0H2a1.968 1.968 0 00-.953.252zm1.939-.368l-1.61 1.409a.5.5 0 01-.658 0l-1.61-1.409-5.116 5.724A1.976 1.976 0 002 12h12a1.976 1.976 0 001.055-.308zM.312.938A1.986 1.986 0 000 2v8a1.976 1.976 0 00.257.962l5.051-5.653z"}})])])
          )
        }
      }
    